<template>
  <div class="action-bar">
    <div class="left-wrap">
      <slot name="left">
        <span v-if="left" @click="back()">
          <i class="icon icon-back"></i>返回
        </span>
      </slot>
    </div>

    <div class="title-wrap">
      <slot name="title">
        <span>{{ title }}</span>
      </slot>
    </div>

    <div class="right-wrap pc-wrap" v-if="pc">
      <slot name="right">
        <div class="right" slot="right">
          <button class="right-pc-btn" @click="gotopc()">电脑版</button>
        </div>
      </slot>
    </div>

    <div class="right-wrap" v-if="l">
      <slot name="right">
        <div class="right" slot="right">
          <button v-if="b" class="back-b" @click="back()">返回</button>
          <button v-else data-list="menu">≡</button>
        </div>
      </slot>
    </div>

    <!-- 右边的menu -->
    <menu-list class="list menu-list" v-show="menu" :list="menuList" :lottery_type="lottery_type"
               @onItemClick="onItemClick"
    ></menu-list>
  </div>
</template>

<script>
import MenuList from "../b-menu-list";
import { mapActions } from "vuex";

export default {
  name: "index",
  components: {
    MenuList
  },
  data() {
    return {
      menu: false,
      menuList: [
        {
          path: "/home/orders",
          value: 1,
          title: "未结明细"
        },
        {
          path: "/home/settled",
          value: 2,
          title: "今日已结"
        },
        {
          path: "/home/history",
          value: 3,
          title: "账户历史"
        },
        {
          path: "/home/result",
          value: 4,
          title: "开奖结果"
        },
        {
          path: "/home/user",
          value: 5,
          title: "个人中心"
        },
        {
          path: "/home/rule",
          value: 6,
          title: "规则说明"
        },
        {
          path: "/home/main",
          value: 7,
          title: "首页"
        },
        {
          path: "/",
          value: 8,
          title: "退出"
        }
      ]
    };
  },
  props: {
    title: [String, Number],
    left: {
      type: Boolean,
      default: true
    },
    right: {
      type: Boolean,
      default: true
    },
    l: {
      type: Boolean,
      default: true
    },
    pc: {
      type: Boolean,
      default: false
    },
    b: {
      type: Boolean,
      default: false
    },
    lottery_type: {
      type: Number,
      default: 1
    }
  },
  methods: {
    ...mapActions("root", ["logout"]),
    gotopc() {
      window.location.href = "https://w.ts608.com/";
    },
    showMenu() {
      this.menu = true;
    },
    hideMenu() {
      this.menu = false;
    },
    toggleMenu() {
      this.menu = !this.menu;
    },
    onItemClick(i) {
      if (i.value === 8) {
        this.logout();
        this.$router.push("/login");
      }
    },
    documentClick(e) {
      if (e.target.dataset.list === "menu") {
        this.toggleMenu();
      } else {
        this.hideMenu();
      }
    },
    back() {
      this.$emit("back");
    }
  },
  mounted() {
    document.addEventListener("click", this.documentClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.documentClick);
  }
};
</script>

<style scoped lang="less">
.action-bar {
  color: #fff;
  height: 80px;
  padding: 0 10px;
  display: flex;
  box-sizing: border-box;
  font-size: 30px;
  background: linear-gradient(#f3382c, #da2d23);
  align-items: center;
  justify-content: space-between;

  .title-wrap {
    flex: 1;
    text-align: center;
  }

  .right-wrap {
    .right {
      width: 140px;
      text-align: right;

      button {
        color: #fff;
        border: 1px solid #b70a00;
        position: relative;
        padding: 0 18px;
        font-size: 44px;
        background: #e8291d;
        background: -webkit-gradient(linear,
        0 0,
        0 70%,
        from(#f94539),
        to(#e8291d));
        box-shadow: 0 2px 2px #fc7f77 inset;
        border-radius: 10px;
        height: 60px;
      }

      .right-pc-btn {
        display: inline-block;
        padding: 0;
        font-weight: 300;
        font-size: 20px;
        width: 80%;
        color: #ffffff;
        background: #cc3636;
        border-radius: 3px;
        margin-right: 5px;
        line-height: 30px;
        border: none;
        box-shadow: none;
      }

      .back-b {
        font-size: 20px;
      }
    }
  }

  .pc-wrap {
    position: absolute;
    right: 10px;
  }
}

.list {
  top: 90px;
  z-index: 100;
  position: absolute;

  &.menu-list {
    right: 0px;

    &:after {
      left: 160px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/action-bar/index.vue